export const Sparkle = ({ className = "", style = {} }) => (
  <svg viewBox="0 0 32 32" className={className} style={style} fill="currentColor" aria-hidden="true">
    <path d="M16 2 L19.5 12.5 L30 16 L19.5 19.5 L16 30 L12.5 19.5 L2 16 L12.5 12.5 Z" />
  </svg>
);
